import { IconArrowRightRegular, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  text: string;
  onClick: () => void;
}

export const StoreDealTitle = ({ text, onClick }: Props) => {
  return (
    <Title onClick={onClick}>
      <Text variant='Body_14_SemiBold' style={{ lineHeight: '150%' }} dangerouslySetInnerHTML={{ __html: text }} />
      <IconArrowRightRegular size={20} color='iconSecondary' />
    </Title>
  );
};

const Title = styled.div`
  margin: 8px 16px 16px 16px;
  padding: 0 12px 0 16px;
  height: 44px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background: ${vars.color.fillTertiary};
`;
